import { SxProps } from "@mui/material";

export const sxTitle: SxProps = {
  fontSize: 25,
  fontFamily: 'UnimedSans-Bold',
  textAlign: 'center',
  width: '100%',
  color: '#383838',
}

export const sxSubTitle: SxProps = {
  fontSize: 14,
  padding: '0px 50px',
  textAlign: 'center',
  width: '100%',
  color: '#383838',
  marginTop: '10px',
  '@media (max-width: 425px)': {
    padding: '0px 5px',
  },
}

export const sxRadioGroup: SxProps = {
  margin: '20px 50px',
  '@media (max-width: 425px)': {
    margin:'20px 0px',
  },
}

export const sxNumberCard: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 12,
  color: '#383838'
}

export const sxNameCard: SxProps = {
  fontSize: 12,
  color: '#383838'
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px'
}